import ServicesMenuProvincia from '../../utils/servicesMenuProvincia';
import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../../services/api';
import CountUp from 'react-countup';
import Loading from '../../load/loading';
import RegisterAccess from '../../utils/registerAccess';

export default function ResumoProvincia() {
  const { provincia } = useParams();
  const [total, setTotal]  = useState(0);
  const [tipos, setTipos]  = useState(null); // null = a carregar

  useEffect(() => {
    Promise.all([
      api.get('/tipo-estabelecimentos'),
      api.get(`/estabelecimentos?provincia=${provincia}&count=true`),
    ]).then(([tiposRes, totalRes]) => {
      setTipos(tiposRes.data.tipoEstabelecimentos ?? []);
      setTotal(totalRes.data.totalItems ?? 0);
    }).catch(() => setTipos([]));
  }, [provincia]);

  return (
    <div className="tw-max-w-5xl tw-mx-auto tw-px-4 tw-pb-12">
      <RegisterAccess page={`Resumo ${provincia}`} />

      {/* Cabeçalho */}
      <div className="tw-flex tw-items-center tw-gap-3 tw-py-6 tw-border-b tw-border-[#85287e]/20 tw-mb-8">
        <div className="tw-w-1.5 tw-h-7 tw-bg-[#85287e] tw-rounded-full tw-flex-shrink-0" />
        <h1 className="tw-text-xl tw-font-extrabold tw-tracking-widest tw-text-[#85287e] tw-uppercase tw-leading-none">
          {provincia}
        </h1>
      </div>

      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-8 tw-items-start">

        {/* ── Mapa ───────────────────── */}
        <div className="tw-flex-shrink-0 tw-flex tw-flex-col tw-items-center">
          <Link
            to={`/admin/provincia/${provincia}/geral`}
            title="Ver listagem geral"
            className="tw-block tw-no-underline tw-group"
          >
            <div className="tw-bg-[#85287e]/5 tw-rounded-2xl tw-p-6 tw-transition-all tw-duration-300 group-hover:tw-bg-[#85287e]/10 group-hover:tw-shadow-md">
              <img
                src={`/icones/mapaProvinciasAngola/${provincia}.svg`}
                alt={provincia}
                className="tw-w-[200px] tw-object-contain"
              />
            </div>
          </Link>

          {/* Total geral */}
          <div className="tw-mt-4 tw-text-center tw-bg-white tw-rounded-xl tw-border tw-border-[#85287e]/20 tw-shadow-sm tw-px-8 tw-py-3 tw-w-full">
            <p className="tw-text-[10px] tw-text-gray-400 tw-uppercase tw-tracking-widest tw-font-semibold tw-mb-0.5">
              Total Geral
            </p>
            <p className="tw-text-3xl tw-font-extrabold tw-text-[#85287e]">
              <CountUp end={total} />
            </p>
          </div>
        </div>

        {/* ── Cards por tipo ─────────── */}
        <div className="tw-flex-1">
          <p className="tw-text-[11px] tw-text-gray-400 tw-uppercase tw-tracking-widest tw-font-semibold tw-mb-4">
            Por tipo de estabelecimento
          </p>

          {tipos === null ? (
            <Loading />
          ) : tipos.length === 0 ? (
            <p className="tw-text-sm tw-text-gray-400">Sem tipos definidos</p>
          ) : (
            <div className="tw-flex tw-flex-wrap tw-gap-4">
              {tipos.map(tipo => (
                <ServicesMenuProvincia
                  key={tipo._id}
                  tipo={tipo}
                  provincia={provincia}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
